import {
  IonButton,
  IonCol,
  IonGrid,
  IonIcon,
  IonLabel,
  IonRow,
} from "@ionic/react";
import dayjs from "dayjs";
import "dayjs/locale/es";
import axios from "axios";
import {
  calendar,
  calendarOutline,
  close,
  closeOutline,
  print,
  printOutline,
} from "ionicons/icons";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { DialogoConfirmacion } from "../../components/basicsComponents/DialogoConfirmacion/DialogoConfirmacion";
import {
  convertToPlain,
  obtenerNombreDia,
} from "../../utils/funcionalidadesStrings";
import {
  Column,
  Row,
} from "../../components/basicsComponents/MaterialGridComponents";
import {
  Accordion,
  AccordionDetails,
  AccordionGroup,
  AccordionSummary,
  Box,
  Button,
  Card,
  Typography,
} from "@mui/joy";
import ComprobanteTurno from "../../components/formComponents/ComprobanteTurno/ComprobanteTurno";
import CustomToast from "../../components/basicsComponents/CustomToast/CustomToast";
import { Close, LibraryAdd, Person, Print } from "@mui/icons-material";
import useTituloPagina from "../../hooks/tituloPagina";
import { DIRECCION_ATENCION } from "../../utils/direccionAtencion";
import {
  esTurnoDelDia,
  MENSAJE_CANCELACION_MISMO_DIA,
} from "../../utils/restriccionCancelacionTurno";

const MainPage = (props) => {
  const colorFondoSecundario = "var(--portal-surface)";
  const colorTextoPrincipal = "var(--portal-text-primary)";
  const colorTextoSecundario = "var(--portal-text-secondary)";
  const colorAcento = "var(--portal-accent)";
  const colorAcentoOscuro = "var(--portal-accent-shade)";
  const [cargando, setCargando] = useState(false);
  const [paciente, setPaciente] = useState({});

  const [turnoSeleccionado, setTurnoSeleccionado] = useState({});
  const [abrirModalCancelarReserva, setAbrirModalCancelarReserva] =
    useState(false);
  const [abrirComprobanteTurno, setAbrirComprobanteTurno] = useState(false);

  const [listadoTurnos, setListadoTurnos] = useState([]);
  const [prestadores, setPrestadores] = useState([]);
  const [prestadoresRecientes, setPrestadoresRecientes] = useState([]);
  const [estudios, setEstudios] = useState([]);
  const [servicios, setServicios] = useState([]);
  const [toast, setToast] = useState({ open: false, mensaje: "", tipo: "" });
  const mostrarNotificacion = (abrir, mensaje, tipo) => {
    let notificacion = {};
    if (abrir) {
      notificacion = { open: true, mensaje: mensaje, tipo: tipo };
    } else {
      notificacion = { open: false, mensaje: "", tipo: "" };
    }
    setToast(notificacion);
  };
  const history = useHistory();
  useTituloPagina();

  const obtenerFotoPrestador = (prestador = {}) => {
    const camposFoto = [
      "foto",
      "Foto",
      "fotoWeb",
      "FotoWeb",
      "imagen",
      "Imagen",
      "imagenWeb",
      "ImagenWeb",
      "fotoBase64",
      "FotoBase64",
      "imagenBase64",
      "ImagenBase64",
    ];
    const campoFoto = camposFoto.find(
      (campo) => prestador?.[campo] !== undefined && prestador?.[campo] !== null,
    );
    const foto = campoFoto ? prestador[campoFoto] : "";

    if (typeof foto !== "string" || foto.trim() === "") {
      return "";
    }

    const fotoNormalizada = foto.trim();
    if (
      fotoNormalizada.startsWith("data:") ||
      fotoNormalizada.startsWith("http://") ||
      fotoNormalizada.startsWith("https://")
    ) {
      return fotoNormalizada;
    }

    const fotoBase64 = fotoNormalizada.replace(/\s/g, "");
    const mimeType = obtenerMimeFotoPrestador(fotoBase64);

    return `data:${mimeType};base64,${fotoBase64}`;
  };

  const obtenerMimeFotoPrestador = (fotoBase64) => {
    if (fotoBase64.startsWith("Qk")) return "image/bmp";
    if (fotoBase64.startsWith("/9j/")) return "image/jpeg";
    if (fotoBase64.startsWith("iVBOR")) return "image/png";
    if (fotoBase64.startsWith("R0lG")) return "image/gif";
    if (fotoBase64.startsWith("UklGR")) return "image/webp";

    return "image/jpeg";
  };

  const agregarFotosPrestadoresRecientes = (
    prestadoresRecientesBase,
    prestadoresBase = prestadores,
  ) => {
    return prestadoresRecientesBase.map((prestadorReciente) => {
      const prestadorCompleto = prestadoresBase.find(
        (prestador) => prestador.codigo === prestadorReciente.prestadorCod,
      );

      return {
        ...prestadorReciente,
        imageSrc:
          prestadorReciente.imageSrc ||
          prestadorCompleto?.imageSrc ||
          obtenerFotoPrestador(prestadorCompleto),
      };
    });
  };

  const traerPrestadores = async (paciente) => {
    try {
      const url = localStorage.getItem("urlAxioPP");
      const config = {
        headers: { Authorization: `Bearer ${paciente.token}` },
      };

      const response = await axios.get(`${url}Prestadores`, config);
      if (response.data.length !== 0) {
        setPrestadores(
          response.data.map((prestador) => ({
            ...prestador,
            imageSrc: obtenerFotoPrestador(prestador),
          })),
        );
      }
    } catch (e) {
      console.error("Error al cargar prestadores:", e);
      mostrarNotificacion(true, "Error al cargar prestadores", "rojo");
    }
  };

  const traerTurnosPaciente = async (paciente) => {
    let turnosFuturos = null;
    let tmpPrestadoresRecientes = null;
    const url = localStorage.getItem("urlAxioPP");
    const config = {
      headers: { Authorization: `Bearer ${paciente.token}` },
    };

    try {
      const servicio = await axios
        .get(`${url}Servicios`, config)
        .then((response) => {
          if (response.data.length !== 0) {
            return response.data;
          } else {
            return null;
          }
        });
      if (servicio !== null) {
        const response = await axios.get(
          `${url}Turnos/TurnosPaciente/?paciente=${paciente.codigo}&servicio=${servicio[0].codigo}`,
          config,
        );
        if (response.data.length !== 0) {
          turnosFuturos = response.data;
          tmpPrestadoresRecientes = response.data;

          //*Logica para los turnos futuros
          turnosFuturos = turnosFuturos.filter((turno) => {
            return dayjs(new dayjs()).isBefore(dayjs(turno.fecha));
          });
          turnosFuturos = turnosFuturos.sort((a, b) => {
            const fechaA = dayjs(a.fecha);
            const fechaB = dayjs(b.fecha);

            if (fechaA.isBefore(fechaB)) {
              return -1;
            } else if (fechaA.isAfter(fechaB)) {
              return 1;
            } else {
              const horaA = dayjs(a.hora, "HH:mm:ss");
              const horaB = dayjs(b.hora, "HH:mm:ss");

              if (horaA.isBefore(horaB)) {
                return -1;
              } else if (horaA.isAfter(horaB)) {
                return 1;
              } else {
                return 0;
              }
            }
          });
          turnosFuturos = turnosFuturos.slice(0, 5);

          tmpPrestadoresRecientes = tmpPrestadoresRecientes
            .sort((a, b) => dayjs(b.fecha).diff(dayjs(a.fecha))) // Orden cronológico inverso
            .filter(
              (value, index, self) =>
                index ===
                self.findIndex(
                  (t) =>
                    t.prestadorCod === value.prestadorCod &&
                    t.prestadorNom === value.prestadorNom,
                ),
            )
            .slice(0, 4)
            .map((turno) => {
              return {
                prestadorCod: turno.prestadorCod,
                prestadorNom: turno.prestadorNom,
                especialidadNom: turno.especialidadNom,
                imageSrc:
                  prestadores.find(
                    (prestador) => prestador.codigo === turno.prestadorCod,
                  )?.imageSrc || "",
              };
            })
            .sort((a, b) => a.prestadorNom.localeCompare(b.prestadorNom));
        } else {
          turnosFuturos = [];
          tmpPrestadoresRecientes = [];
        }
        setListadoTurnos(turnosFuturos);
        setPrestadoresRecientes(
          agregarFotosPrestadoresRecientes(tmpPrestadoresRecientes),
        );
      }
    } catch (e) {
      mostrarNotificacion(
        true,
        "Ocurrió un problema al intentar consultar sus Próximos turnos",
        "rojo",
      );
    }
  };

  const traerEstudios = async (paciente) => {
    let estudios = [];
    const url = localStorage.getItem("urlAxioPP");
    const config = {
      headers: { Authorization: `Bearer ${paciente.token}` },
    };

    try {
      const response = await axios.get(`${url}Estudios`, config);
      if (response.data.length !== 0) {
        estudios = response.data;
      }

      estudios = estudios.map((estudio) => {
        return {
          ...estudio,
          text: estudio.nombre,
        };
      });

      setEstudios(estudios);
    } catch (e) {
      mostrarNotificacion(
        true,
        "Se produjo un error al consultar l registradas en el sistema",
        "rojo",
      );
    }
  };

  const TraerServicio = async (paciente) => {
    try {
      let servicioResponse = {};
      const url = localStorage.getItem("urlAxioPP");
      const config = {
        headers: { Authorization: `Bearer ${paciente.token}` },
      };
      servicioResponse = await axios
        .get(`${url}Servicios`, config)
        .then((response) => {
          if (response.data.length !== 0) {
            return response.data;
          }
        });
      setServicios(servicioResponse);
    } catch (e) {}
  };
  const CancelarTurno = async () => {
    try {
      if (!turnoSeleccionado?.codigo) {
        mostrarNotificacion(true, "No se encontró el turno a cancelar", "rojo");
        return false;
      }

      if (esTurnoDelDia(turnoSeleccionado.fecha)) {
        mostrarNotificacion(true, MENSAJE_CANCELACION_MISMO_DIA, "rojo");
        return false;
      }

      const urlAxioPP = localStorage.getItem("urlAxioPP");
      const config = {
        headers: { Authorization: `Bearer ${paciente.token}` },
      };

      const cancelarTurnoResponse = await axios.patch(
        `${urlAxioPP}Turnos/Cancelar/${turnoSeleccionado.codigo}`,
        "",
        config,
      );
      const quitarTurnoResponse = await axios.patch(
        `${urlAxioPP}Turnos/Quitar/${turnoSeleccionado.codigo}`,
        "",
        config,
      );

      const cancelacionExitosa =
        cancelarTurnoResponse.status >= 200 &&
        cancelarTurnoResponse.status < 300 &&
        quitarTurnoResponse.status >= 200 &&
        quitarTurnoResponse.status < 300;

      if (cancelacionExitosa) {
        mostrarNotificacion(true, "El turno se cancelo correctamente", "verde");
        return true;
      }

      mostrarNotificacion(
        true,
        "Ocurrió un problema al intentar cancelar el turno",
        "rojo",
      );
      return false;
    } catch (error) {
      const mensajeError =
        error?.response?.data?.message ||
        error?.response?.data ||
        error.message ||
        "Ocurrió un problema al intentar cancelar el turno";
      mostrarNotificacion(true, "Error: " + mensajeError, "rojo");
      return false;
    }
  };

  useEffect(() => {
    setCargando(true);
    try {
      const sesion = JSON.parse(sessionStorage.getItem("ppUL"));
      if (sesion) {
        traerTurnosPaciente(sesion);
        traerEstudios(sesion);
        TraerServicio(sesion);
        traerPrestadores(sesion);
        setPaciente(sesion);
        document.title = localStorage.getItem("tituloWeb");
      }
    } catch (e) {
      history.push({ pathname: "/ErrorPage" });
    }
    setCargando(false);
  }, []);

  useEffect(() => {
    if (prestadores.length === 0 || prestadoresRecientes.length === 0) {
      return;
    }

    setPrestadoresRecientes((prestadoresRecientesActuales) =>
      agregarFotosPrestadoresRecientes(
        prestadoresRecientesActuales,
        prestadores,
      ),
    );
  }, [prestadores]);

  const handleClickRedirigir = (destino) => {
    switch (destino) {
      case "Reservar turno":
        history.push({ pathname: "/portal/Reservar turno" });
        break;
      case "Horarios":
        history.push({ pathname: "/portal/Horarios" });
        break;
      case "Turnos":
        history.push({ pathname: "/portal/Turnos" });
        break;
      case "Estudios":
        history.push({ pathname: "/portal/Estudios" });
        break;
      default:
        mostrarNotificacion(true, "Seleccion invalida", "rojo");
        break;
    }
  };

  const togleAbrirCerrarCancelarReserva = () => {
    if (abrirModalCancelarReserva) {
      setTurnoSeleccionado({});
    }
    setAbrirModalCancelarReserva(!abrirModalCancelarReserva);
  };

  const handleClickSeleccionarTurno = (turno) => {
    if (esTurnoDelDia(turno.fecha)) {
      mostrarNotificacion(true, MENSAJE_CANCELACION_MISMO_DIA, "rojo");
      return;
    }
    setTurnoSeleccionado(turno);
    togleAbrirCerrarCancelarReserva();
  };

  const handleClickCancelarReserva = async () => {
    togleAbrirCerrarCancelarReserva();
    setCargando(true);
    const cancelacionExitosa = await CancelarTurno();
    if (cancelacionExitosa) {
      await traerTurnosPaciente(paciente);
    }
    setCargando(false);
  };

  const handleClickCopiarTelefono = () => {
    const phoneNumber = "Solicitar numero";
    navigator.clipboard.writeText(phoneNumber);

    mostrarNotificacion(
      true,
      "Se ha copiado el numero de telefono a su portapapeles",
      "",
    );
  };

  const handleClickComprobanteTurno = (turno) => {
    const lugarAtencion = DIRECCION_ATENCION;

    setTurnoSeleccionado({
      codigo: turno.codigo,
      equipoNom: turno.equipoNom,
      especialidadNom: turno.especialidadNom,
      estudioNom: turno.estudioNom,
      fecha: turno.fecha,
      hora: turno.hora,
      mutualNom: turno.mutualNom,
      prestadorNom: turno.prestadorNom,
      servicio: turno.servicio,
      apellido: paciente.apellido,
      nombre: paciente.nombre,
      mutualNombre: paciente.mutualNombre,
      mutualAfiliado: paciente.mutualAfiliado,
      hc: paciente.hc,
      documentoTipoNombre: paciente.documentoTipoNombre,
      documentoNro: paciente.documentoNro,
      celular: paciente.celular,
      email: paciente.email,
      lugarAtencion,
      preparacionEstudio: null,
    });
    setAbrirComprobanteTurno(true);
  };

  const togleAbrirCerrarComprobanteTurno = () => {
    if (abrirComprobanteTurno) {
      setTurnoSeleccionado({});
    }
    setAbrirComprobanteTurno(!abrirComprobanteTurno);
  };

  const handleClickReservarTurnoPrestador = async (prestadorCod) => {
    setCargando(true);

    try {
      const url = localStorage.getItem("urlAxioPP");
      const config = {
        headers: { Authorization: `Bearer ${paciente.token}` },
      };

      const response = await axios.get(
        `${url}Prestadores?mutuales=${paciente.mutual}`,
        config,
      );

      if (response.data.length !== 0) {
        let prestadores = response.data;

        prestadores = prestadores.filter(
          (prestador) => prestador.vigente === true,
        );

        let edad = dayjs(dayjs()).diff(paciente.nacimiento, "year");

        prestadores = prestadores.filter((prestador) => {
          if (prestador.filtroEdad) {
            if (prestador.edadDesde <= edad && edad <= prestador.edadHasta)
              return prestador;
          } else {
            return prestador;
          }
        });

        if (edad <= 15) {
          prestadores = prestadores.filter((prestador) =>
            [125, 115].includes(prestador.especialidad),
          );
        } else {
          prestadores = prestadores.filter(
            (prestador) => ![125, 115].includes(prestador.especialidad),
          );
        }

        const prestadorEncontrado = prestadores.find(
          (prestador) => prestador.codigo === prestadorCod,
        );

        if (prestadorEncontrado) {
          history.push({
            pathname: "/portal/Reservar turno",
            state: { prestador: prestadorCod },
          });
        } else {
          mostrarNotificacion(
            true,
            "El prestador ya no está disponible, se redirige a seleccionar una Especialidad",
            "amarillo",
          );

          setTimeout(() => {
            history.push({
              pathname: "/portal/Reservar turno",
            });
          }, 2000);
        }
      } else {
        mostrarNotificacion(
          true,
          "No hay prestadores disponibles en este momento",
          "amarillo",
        );

        setTimeout(() => {
          history.push({
            pathname: "/portal/Reservar turno",
          });
        }, 2000);
      }
    } catch (e) {
      console.error("Error al verificar prestador:", e);
      mostrarNotificacion(
        true,
        "Error al verificar la disponibilidad del prestador, se redirige a seleccionar una Especialidad",
        "rojo",
      );

      setTimeout(() => {
        history.push({
          pathname: "/portal/Reservar turno",
        });
      }, 2000);
    } finally {
      setCargando(false);
    }
  };

  const renderPrestadoresRecientes = (seePreviusVersion) => {
    return (
      <Row
        style={{ textAlign: "start" }}
        alignItems="stretch"
        container
        spacing={2}
      >
        {prestadoresRecientes.map((fila) => (
          <Column key={fila.prestadorCod} xs={12} md={6} xl={4}>
            <Card
              variant="outlined"
              sx={{
                mb: 1,
                px: { xs: 1.25, sm: 1.5 },
                py: { xs: 1, sm: 1.25 },
                borderRadius: "14px",
                borderColor: "rgba(var(--portal-accent-rgb), 0.18)",
                background: `linear-gradient(180deg, ${colorFondoSecundario} 0%, #ffffff 72%)`,
                boxShadow: "0 10px 22px rgba(34, 59, 105, 0.08)",
              }}
            >
              <Row style={{ textAlign: "start" }} alignItems="center" container>
                <Column xs={12} sm={8} sx={{ padding: "6px" }}>
                  <Row alignItems="center" sx={{ gap: 1 }}>
                    {fila.imageSrc ? (
                      <Box
                        sx={{
                          width: 32,
                          height: 32,
                          borderRadius: "50%",
                          overflow: "hidden",
                          backgroundColor: "#ffffff",
                          border: "2px solid rgba(var(--portal-accent-rgb), 0.22)",
                          flexShrink: 0,
                        }}
                      >
                        <Box
                          component="img"
                          src={fila.imageSrc}
                          alt={fila.prestadorNom}
                          sx={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            objectPosition: "center 10%",
                            transform: "scale(1.65)",
                            transformOrigin: "center 12%",
                          }}
                        />
                      </Box>
                    ) : (
                      <Person
                        sx={{
                          color: colorTextoPrincipal,
                          backgroundColor:
                            "rgba(var(--portal-accent-rgb), 0.12)",
                          borderRadius: "50%",
                          padding: "4px",
                          fontSize: "1.2rem",
                        }}
                      />
                    )}
                    <Typography
                      sx={{
                        color: colorTextoPrincipal,
                        fontWeight: 700,
                        lineHeight: 1.3,
                        display: "-webkit-box",
                        WebkitBoxOrient: "vertical",
                        WebkitLineClamp: 2,
                        overflow: "hidden",
                        minHeight: "2.6em",
                      }}
                      level="title-sm"
                    >
                      {`${fila.prestadorNom} - ${fila.especialidadNom}`}
                    </Typography>
                  </Row>
                </Column>
                <Column
                  xs={12}
                  sm={4}
                  sx={{
                    padding: "6px",
                    textAlign: { xs: "left", sm: "right" },
                  }}
                >
                  <Button
                    variant="solid"
                    size="sm"
                    onClick={() => {
                      handleClickReservarTurnoPrestador(fila.prestadorCod);
                    }}
                    startDecorator={<LibraryAdd />}
                    sx={{
                      minWidth: { xs: "100%", sm: "165px" },
                      backgroundColor: colorAcento,
                      color: "#ffffff",
                      borderRadius: "10px",
                      fontWeight: 700,
                      letterSpacing: "0.02em",
                      "&:hover": {
                        backgroundColor: colorAcentoOscuro,
                      },
                    }}
                  >
                    {`RESERVAR TURNO`}
                  </Button>
                </Column>
              </Row>
            </Card>
          </Column>
        ))}
      </Row>
    );
  };

  const renderTurnosLista = (seePreviusVersion) => {
    return (
      <IonGrid
        className="tabla"
        style={{
          margin: "10px",
          padding: "10px",
          borderRadius: "5px",
        }}
      >
        {listadoTurnos.filter(
          (fila) => fila.aCancelar && dayjs(fila.fecha).isAfter(new Date()),
        ).length > 0 && (
          <>
            <IonIcon slot="start" md={calendar} ios={calendarOutline} />
            <Column className="" xs={12} marginBottom={1}>
              <Row>
                <Typography level="body-sm">Próximos turnos</Typography>
              </Row>
            </Column>
          </>
        )}
        {listadoTurnos
          .filter(
            (fila) => fila.aCancelar && dayjs(fila.fecha).isAfter(new Date()),
          )
          .map((fila) => (
            <Card
              style={{ marginBottom: "7.5px", padding: "0px 14px" }}
              key={fila.codigo}
            >
              <Row
                className=""
                style={{ textAlign: "start" }}
                alignItems="center"
                container
              >
                <Column
                  style={{ textAlign: "start" }}
                  xs={6}
                  md={8}
                  lg={10}
                  container
                >
                  <Row alignItems="center" container>
                    <Column xs={12} md={6}>
                      <Typography
                        level="title-sm"
                        sx={{ color: colorTextoPrincipal }}
                      >
                        {fila.prestadorNom === "EQUIPOS"
                          ? `${fila.estudioNom}`
                          : `${fila.prestadorNom + " - " + fila.especialidadNom}`}
                      </Typography>
                    </Column>
                    <Column xs={12} md={6}>
                      <Typography level="title-sm">
                        {`${obtenerNombreDia(dayjs(fila.fecha).format("dddd"))} ${dayjs(fila.fecha).format("DD")} de ${dayjs(
                          fila.fecha,
                        ).format(
                          "MMMM, YYYY",
                        )} a las ${dayjs(fila.hora).format("HH:mm")}`}
                      </Typography>
                    </Column>
                  </Row>
                  <Row className="" alignItems="center" container>
                    <Column xs={12} md={6}>
                      <Typography level="body-sm">{`${fila.mutualNom}`}</Typography>
                    </Column>
                    <Column xs={12} md={6}>
                      <Typography level="body-sm">{`Estado: ${fila.asistio ? "Asistido" : fila.aCancelar ? "Pendiente" : "Cancelado"}`}</Typography>
                    </Column>
                  </Row>
                  <Row className="" alignItems="center" container>
                    <Column xs={12}>
                      <Typography level="body-sm">
                        {fila.prestadorNom === "EQUIPOS" &&
                        estudios.filter(
                          (estudio) => estudio.codigo === fila.estudio,
                        )[0]?.preparacion !== ""
                          ? convertToPlain(
                              estudios.filter(
                                (estudio) => estudio.codigo === fila.estudio,
                              )[0]?.preparacion,
                            )
                          : null}
                      </Typography>
                    </Column>
                  </Row>
                </Column>
                <Column container xs={6} md={4} lg={2}>
                  <Row container>
                    {(dayjs().format("YYYY-MM-DD") !==
                      dayjs(fila.fecha).format("YYYY-MM-DD") ||
                      (dayjs().format("YYYY-MM-DD") ===
                        dayjs(fila.fecha).format("YYYY-MM-DD") &&
                        dayjs(fila.hora).format("HH:mm") >
                          dayjs().format("HH:mm"))) &&
                    fila.aCancelar ? (
                      <Column xs={12} container>
                        <IonButton
                          shape="roud"
                          fill="clear"
                          onClick={() => handleClickComprobanteTurno(fila)}
                          style={{ margin: "0px" }}
                        >
                          <IonIcon
                            aria-label="Cancelar turno"
                            ios={printOutline}
                            md={print}
                            style={{ color: colorTextoPrincipal }}
                          />
                          <IonLabel style={{ color: colorTextoPrincipal }}>
                            Comprobante
                          </IonLabel>
                        </IonButton>
                        <IonButton
                          shape="roud"
                          fill="clear"
                          onClick={() => handleClickSeleccionarTurno(fila)}
                          style={{ margin: "0px" }}
                        >
                          <IonIcon
                            aria-label="Cancelar turno"
                            ios={closeOutline}
                            md={close}
                            style={{ color: colorTextoPrincipal }}
                          />
                          <IonLabel style={{ color: colorTextoPrincipal }}>
                            Cancelar
                          </IonLabel>
                        </IonButton>
                      </Column>
                    ) : (
                      <Column className="" xs={12} container>
                        <IonButton
                          shape="roud"
                          fill="clear"
                          onClick={() => handleClickComprobanteTurno(fila)}
                          style={{ margin: "0px" }}
                        >
                          <IonIcon
                            aria-label="Cancelar turno"
                            ios={printOutline}
                            md={print}
                            style={{ color: colorTextoPrincipal }}
                          />
                          <IonLabel style={{ color: colorTextoPrincipal }}>
                            Comprobante
                          </IonLabel>
                        </IonButton>

                        <IonButton
                          shape="roud"
                          fill="clear"
                          onClick={() =>
                            handleClickReservarTurnoPrestador(fila.prestadorCod)
                          }
                          style={{ margin: "0px" }}
                        >
                          <Typography
                            level="title-sm"
                            sx={{ color: colorTextoPrincipal }}
                          >
                            {`Reservar turno`.toUpperCase()}
                          </Typography>
                          <LibraryAdd sx={{ color: colorAcento }} />
                        </IonButton>
                      </Column>
                    )}
                  </Row>
                </Column>
              </Row>
            </Card>
          ))}
      </IonGrid>
    );
  };

  const renderAccesoRapido = (emoji, titulo, subtitulo, accion) => (
    <Card
      variant="outlined"
      onClick={() => handleClickRedirigir(accion)}
      role="button"
      tabIndex={0}
      onKeyDown={(event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          handleClickRedirigir(accion);
        }
      }}
      sx={{
        borderRadius: "14px",
        borderColor: "rgba(var(--portal-accent-rgb), 0.20)",
        background: `linear-gradient(145deg, ${colorFondoSecundario} 0%, #ffffff 78%)`,
        boxShadow: "0 10px 22px rgba(38, 58, 101, 0.10)",
        cursor: "pointer",
        transition:
          "transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease",
        "&:hover": {
          transform: "translateY(-2px)",
          boxShadow: "0 14px 24px rgba(var(--portal-accent-rgb), 0.14)",
          borderColor: "rgba(var(--portal-accent-rgb), 0.32)",
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1.25,
          p: { xs: 1.25, sm: 1.5 },
        }}
      >
        <Box
          sx={{
            width: 42,
            height: 42,
            borderRadius: "50%",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "rgba(var(--portal-accent-rgb), 0.14)",
            border: "1px solid rgba(var(--portal-accent-rgb), 0.26)",
            flexShrink: 0,
          }}
        >
          <Typography sx={{ fontSize: "1.25rem", lineHeight: 1 }}>
            {emoji}
          </Typography>
        </Box>

        <Box sx={{ flex: 1, minWidth: 0, textAlign: "left" }}>
          <Typography
            level="title-md"
            sx={{
              color: colorTextoPrincipal,
              fontWeight: 700,
              lineHeight: 1.2,
            }}
          >
            {titulo}
          </Typography>
          <Typography
            level="body-xs"
            sx={{ color: colorTextoSecundario, mt: 0.25 }}
          >
            {subtitulo}
          </Typography>
        </Box>

        <Box
          sx={{
            width: 34,
            height: 34,
            borderRadius: "50%",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "rgba(var(--portal-accent-rgb), 0.10)",
            flexShrink: 0,
          }}
        >
          <Typography
            sx={{ fontSize: "1.05rem", lineHeight: 1, color: colorAcento }}
          >
            ➡️
          </Typography>
        </Box>
      </Box>
    </Card>
  );

  return (
    <IonGrid>
      <IonRow>
        <IonCol sizeXs="12" sizeMd="6">
          {renderAccesoRapido(
            "🩺",
            "Reservar un nuevo turno",
            "Elegí especialidad y profesional",
            "Reservar turno",
          )}
        </IonCol>
        {/*<IonCol sizeXs="12" sizeMd="6">
          <IonItem
            lines="none"
            onClick={() => handleClickRedirigir("Horarios")}
            className="amarillo-sol"
          >
            <IonAvatar slot="start">
              <IonIcon ios={peopleOutline} md={people} size="large" />
            </IonAvatar>
            <Typography level="body-md">Horarios de nuestros prestadores</Typography>
            <IonAvatar slot="end">
              <IonIcon ios={chevronForwardOutline} md={chevronForward} size="large" />
            </IonAvatar>
          </IonItem>
        </IonCol>*/}
        <IonCol sizeXs="12" sizeMd="6">
          {renderAccesoRapido(
            "📅",
            "Consultar mis turnos",
            "Revisá próximos y anteriores",
            "Turnos",
          )}
        </IonCol>
        {/* <IonCol sizeXs="12" sizeMd="6">
          <IonItem lines="none" onClick={() => handleClickRedirigir("Estudios")} className="amarillo-sol">
            <IonAvatar slot="start">
              <IonIcon ios={fileTrayFullOutline} md={fileTrayFull} size="large" />
            </IonAvatar>
            <Typography level="body-md">Consultar mis estudios</Typography>
            <IonAvatar slot="end">
              <IonIcon ios={chevronForwardOutline} md={chevronForward} size="large" />
            </IonAvatar>
          </IonItem>
        </IonCol> */}
      </IonRow>

      {listadoTurnos.length !== 0 && renderTurnosLista(true)}
      {prestadoresRecientes.length !== 0 && (
        <AccordionGroup>
          <Accordion
            defaultExpanded
            sx={{
              borderRadius: "14px",
              overflow: "hidden",
              borderColor: "rgba(var(--portal-accent-rgb), 0.18)",
              background: `linear-gradient(180deg, rgba(var(--portal-accent-rgb), 0.12), #ffffff 36%)`,
            }}
          >
            <AccordionSummary
              sx={{ color: colorTextoPrincipal, fontWeight: 700 }}
            >
              Prestadores recientes
            </AccordionSummary>
            <AccordionDetails sx={{ pt: 1 }}>
              {renderPrestadoresRecientes()}
            </AccordionDetails>
          </Accordion>
        </AccordionGroup>
      )}

      <DialogoConfirmacion
        titulo="Cancelar turno"
        texto={`Ha decidido cancelar el turno con el/la profesional ${turnoSeleccionado.prestadorNom}, con especialidad en ${
          turnoSeleccionado.especialidadNom
        }, para el día ${obtenerNombreDia(dayjs(turnoSeleccionado.fecha).format("dddd"))} ${dayjs(turnoSeleccionado.fecha).format("DD")} de ${dayjs(
          turnoSeleccionado.fecha,
        ).format(
          "MMMM, YYYY",
        )} a las ${dayjs(turnoSeleccionado.hora).format("HH:mm")}, ¿Esta seguro/a de ello?`}
        open={abrirModalCancelarReserva}
        setOpen={setAbrirModalCancelarReserva}
        handleClickConfirmar={handleClickCancelarReserva}
        colorBotonNo="danger"
        colorBotonSi="success"
        textoBotonNo="No"
        textoBotonSi="Si, cancelo"
      />

      <ComprobanteTurno
        turno={turnoSeleccionado}
        abrir={abrirComprobanteTurno}
        togleAbrirCerrarComprobanteTurno={togleAbrirCerrarComprobanteTurno}
        paciente={paciente}
      />

      <CustomToast
        openToast={toast.open}
        onDidDismiss={(e) => mostrarNotificacion(false, "", "")}
        message={toast.mensaje}
        colorNotificacion={toast.tipo}
        duration={toast.mensaje === MENSAJE_CANCELACION_MISMO_DIA ? 10000 : 5000}
      />
    </IonGrid>
  );
};

export default MainPage;
